import { useState, useRef } from 'react';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';
import camilleImg from '../../../../assets/images/camille.png';
import andreasImg from '../../../../assets/images/andreas.png';
import javierImg from '../../../../assets/images/javier.png';
import meilingImg from '../../../../assets/images/meiling.png';
import { useRemoteConfig } from 'core/hooks/use-remote-config';

import getLocale from 'src/localization/get-locale';
import { StarIcon } from 'src/onboarding/assets/icons/StarIcon';
import { AppleIcon } from 'src/onboarding/assets/icons/AppleIcon';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';

interface Customer {
  img: string;
  name: string;
  prof: string;
}

export const CustomersComponent = () => {
  const { customersReview } = useRemoteConfig();
  const locale = getLocale();
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const defaultCustomers: Customer[] = [
    {
      img: camilleImg,
      name: t('onboarding.voeryPersonalPlan.customersReviews.customers.cammile.name'),
      prof: t('onboarding.voeryPersonalPlan.customersReviews.customers.cammile.prof'),
    },
    {
      img: andreasImg,
      name: t('onboarding.voeryPersonalPlan.customersReviews.customers.andreas.name'),
      prof: t('onboarding.voeryPersonalPlan.customersReviews.customers.andreas.prof'),
    },
    {
      img: javierImg,
      name: t('onboarding.voeryPersonalPlan.customersReviews.customers.javier.name'),
      prof: t('onboarding.voeryPersonalPlan.customersReviews.customers.javier.prof'),
    },
    {
      img: meilingImg,
      name: t('onboarding.voeryPersonalPlan.customersReviews.customers.meiling.name'),
      prof: t('onboarding.voeryPersonalPlan.customersReviews.customers.meiling.prof'),
    },
  ];

  const customersWithReviews = defaultCustomers
    .map((customer, index) => {
      const review = customersReview?.[index];
      const reviewText = review?.text?.[locale] || review?.text?.en || '';

      return {
        ...customer,
        review: reviewText,
      };
    })
    .filter((customer) => customer.review);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const minSwipeDistance = 50;
    const swipeDistance = touchEndX.current - touchStartX.current;

    if (Math.abs(swipeDistance) > minSwipeDistance) {
      if (swipeDistance > 0 && currentIndex > 0) {
        // Свайп вправо - предыдущий отзыв
        setCurrentIndex(currentIndex - 1);
      } else if (swipeDistance < 0 && currentIndex < customersWithReviews.length - 1) {
        // Свайп влево - следующий отзыв
        setCurrentIndex(currentIndex + 1);
      }
    }

    // Сброс значений
    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  return (
    <div className={styles.reviews}>
      <div 
        className={styles.customers}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {customersWithReviews.map(({ img, name, prof, review }, index) => (
          <div 
            className={`${styles.customer} ${index === currentIndex ? styles.active : ''}`} 
            key={index}
            style={{ display: index === currentIndex ? 'flex' : 'none' }}
          >
            <div className={styles.reviewHeader}>
              <div className={styles.appStore}>
                <AppleIcon />
                <Typography variant='body-semibold'>
                  {t('onboarding.voeryPersonalPlan.customersReviews.appStore')}
                </Typography>
              </div>

              <div className={styles.rate}>
                {Array.from({ length: 5 }, (_, i) => (
                  <StarIcon key={i} color='#007CFF' />
                ))}
              </div>
            </div>
            
            <div className={styles.customerReview}>
              <Typography variant='h1-bold'>{review}</Typography>
            </div>

            <div className={styles.customerBottom}>
              <img className={styles.customerImg} src={img} alt={name} />
              <div className={styles.customerDesc}>
                <Typography variant='callout-medium'>{name}</Typography>
                <Typography variant='caption-tabBar'>{prof}</Typography>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.pagination}>
        {customersWithReviews.map((_, i) => (
          <span 
            key={i} 
            className={i === currentIndex ? styles.active : ''}
          />
        ))}
      </div>
    </div>
  );
};
